<template>
	<main class="mypage recurring_payment">
		<UserMenu v-if="displayStore.isDesktop" />
		<article class="recurring_payment_info">
			<h6>정기 결제 내역</h6>
			<section>
				<ul class="history_board payment_board">
					<li v-for="(item, idx) in memberSubscriptionDetailMoreData?.pay_info" :key="idx">
						<p>
							<span>결제금액:</span><span>{{ numberFormat(item.pay_info_goods_price) }}원</span>
						</p>
						<p>
							<span>결제일시:</span><span>{{ item.pay_datetime }}</span>
						</p>
					</li>
				</ul>
				<Pagination
					v-if="memberSubscriptionDetailMoreData?.pay_info_cnt"
					:current-page="Number(route.query.page ?? 1)"
					:total-count="
						memberSubscriptionDetailMoreData?.pay_info_cnt
							? Math.ceil(memberSubscriptionDetailMoreData?.pay_info_cnt / 10)
							: 0
					"
					@set-page="(page) => router.replace({ query: { ...route.query, page: page } })"
				/>
			</section>
		</article>
	</main>
</template>

<script setup lang="ts">
// core
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

// api
import { useGetMemberSubscriptionDetailMoreApi } from '@/api/mypage';
// component
import UserMenu from '@/components/mypage/UserMenu.vue';
// store
import { useDisplayStore } from '@/stores/display';
// util
import { numberFormat } from '@/utils/function/format';

// -----variable-----
const displayStore = useDisplayStore();
const route = useRoute();
const router = useRouter();
// -----api-----
const { data: memberSubscriptionDetailMoreData } = useGetMemberSubscriptionDetailMoreApi(
	computed(() => {
		return { subscription_pk: Number(route.params.subscription_pk), page: Number(route.query.page ?? 1), view: 10 };
	})
);
</script>

<style lang="scss" scoped>
.recurring_payment {
	gap: 8rem;
	margin-bottom: 8.8rem;
	&_info {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 4rem;
	}
	@media screen and (max-width: 1280px) {
		margin-top: 4rem;
		padding-bottom: var(--bottomMenu-height);
		margin-bottom: 4rem;
	}
}
.payment_board {
	padding-left: 0rem;
	padding-right: 0rem;

	// @media screen and (max-width: 1280px) {
	// 	padding-top: 4rem;
	// }
	li {
		p {
			display: flex;
			gap: 0.4rem;
			span {
				font-weight: var(--font-w-light);
				font-size: var(--font-s-small);
				line-height: 1.551rem;
				color: var(--color-base-white);
			}
		}
	}
	padding-bottom: 2rem;
}
</style>
